import { DB } from ".";
import { KKAuth } from "../api";
import time from "../time";

const insert_qh_sql =
    "insert or replace into t_qh_auth(qid, uidA,uidB,time) values(?, ?, ?, ?)"

export async function auth_qh_insert(
    db: DB,
    auth: QhAuth
): Promise<{ error: any }> {
    if (!auth.uidA || auth.uidA === 0 || !auth.uidB || auth.uidB === 0) {
        return { error: -1 }
    }
    const unixTime = time.toUnixMillSecond(time.now());
    const parms = [auth.qhId, auth.uidA, auth.uidB, unixTime,];
    const r = await db.Execute(insert_qh_sql, parms);
    return { error: r.error };
}

export async function qry_qh_auth(db: DB, uid: number): Promise<{ error?: any, uids?: { uidA: number, uidB: number }[] }> {
    const sql = `select uidA,uidB from t_qh_auth where uidA = ? or uidB = ? order by time desc`
    const r = await db.Query(sql, [uid, uid])
    if (r.data && r.data.length > 0) {
        return { uids: r.data }
    }
    return { error: r.error }
}

export async function del_qh_auth(db: DB, uid: number, delUid: number) {
    const qid = getQhId(uid, delUid)
    const sql = `DELETE FROM t_qh_auth WHERE qid = ?`
    const r = await db.Execute(sql, [qid])
    return r
}

export function getQhId(uidA: number, uidB: number) {
    return uidA > uidB ? `qh_${uidA}_${uidB}` : `qh_${uidB}_${uidA}`
}

const insert_sql =
    "insert or replace into t_auth(uid,token, appkey,vcode,customerServiceUrl,secret,encrypt,loginType,account,phone,nick,avatar,utime,switch_regist, switch_tab_main, switch_tab_mine,switch_rtc) values(?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?, ?)"
export async function auth_insert(
    db: DB,
    auth: KKAuth & Auth
): Promise<{ error: any }> {
    if (!auth.uid || auth.uid === 0) {
        return { error: -1 }
    }
    const qrySql = "SELECT uid FROM t_auth  ORDER BY utime ASC"
    const qry = await db.Query(qrySql, []);
    let auths = []
    if (qry.data && qry.data.length > 0) {
        auths = qry.data.filter(v => v.uid !== auth.uid)
        if (auths.length > 4) {
            await del_auths(db, auths[0].uid)
        }
    }
    const unixTime = time.toUnixMillSecond(time.now());
    const parms = [
        auth.uid, auth.token, auth.appkey, auth.vcode, auth.customerServiceUrl, auth.secret, auth.encrypt, auth.loginType,
        auth.account, auth.phone, auth.nick, auth.avatar, unixTime, auth.switch_regist, auth.switch_tab_main, auth.switch_tab_mine, auth.switch_rtc];
    const r = await db.Execute(insert_sql, parms);
    return { error: r.error };
}

export async function qry_all_auth(db: DB,): Promise<{ error?: any, auths?: (KKAuth & Auth)[] }> {
    const sql = `SELECT * FROM t_auth  ORDER BY utime DESC`;
    const r = await db.Query(sql, []);
    if (r.data && r.data.length > 0) {
        return { auths: r.data }
    }
    return { error: r.error }
}

export async function qry_auth(db: DB, uid: number): Promise<{ error?: any, auths?: (KKAuth & Auth)[] }> {
    const sql = `SELECT * FROM t_auth WHERE uid=?  ORDER BY utime DESC`;
    const r = await db.Query(sql, [uid]);
    if (r.data && r.data.length > 0) {
        return { auths: r.data }
    }
    return { error: r.error }
}

export async function del_auths(db: DB, uid: number) {
    if (!uid) return;
    const sql = `DELETE FROM t_auth WHERE uid = ?`
    return await db.Execute(sql, [uid])
}

export async function clear_auths(db: DB) {
    const sql = `DELETE FROM t_auth`
    return await db.Execute(sql, [])
}

export type Auth = {
    loginType: number,//0 账号登录，1 手机登录
    account: string, //账号
    phone: string, //手机
    nick: string
    avatar?: string
}
export type QhAuth = {
    qhId: string
    uidA: number,
    uidB: number, //账号
}